const SUG = {
    courses: ["B.Tech", "B.E.", "M.Tech", "MBA", "B.Sc", "B.Com", "BCA", "MCA", "Diploma"],
    specializations: ["Computer Science", "Electronics", "Mechanical", "Civil", "Data Science", "AI/ML", "Finance"],
    institutes: ["IIT Madras", "Anna University", "Government College of Engineering, Krishnagiri", "BITS Pilani", "NIT Trichy", "SRM University"],
    skills: ["React", "JavaScript", "Python", "Django", "Flask", "FastAPI", "SQL", "Postgres", "MongoDB", "HTML", "CSS"],
    domains: ["Web", "Mobile", "ML/AI", "Embedded", "Data Engineering", "DevOps"],
    locations: ["Bangalore", "Chennai", "Hyderabad", "Pune", "Mumbai", "Delhi", "Kolkata"],
    languages: ["English", "Hindi", "Tamil", "Telugu", "Kannada", "Malayalam"],
    companies:["infosys","tcs","wipro","compuet technologies"],
  };
  export default SUG;
  